// Route metadata stays independent of page code so navigation does not load every feature.
export const ACCOUNTING_PAGES = {
  configuration: { title: "Accounting configuration", section: "Configuration", feature: "configuration" },
  accounts: { title: "Chart of accounts", section: "Chart of accounts", feature: "accounts" },
  suppliers: { title: "Suppliers", section: "Suppliers", feature: "suppliers" },
  journals: { title: "Journals", section: "Journals", feature: "journals" },
  ledger: { title: "Ledgers and cash / bank books", section: "Ledgers & books", feature: "ledger" },
  "trial-balance": { title: "Trial balance", section: "Financial reports", feature: "trial_balance" },
  "profit-loss": { title: "Profit and loss", section: "Financial reports", feature: "profit_and_loss" },
  "balance-sheet": { title: "Balance sheet", section: "Financial reports", feature: "balance_sheet" },
  "period-locks": { title: "Period locks", section: "Periods", feature: "period_locks" },
};

export const FINANCE_PAGES = {
  vouchers: { title: "Cash vouchers", feature: "vouchers" },
  "booking-terms": { title: "Booking discounts and installments", feature: "booking_terms" },
  bills: { title: "Bills", feature: "bills" },
  payments: { title: "Payments and allocations", feature: "payments" },
  instruments: { title: "Pay orders and post-dated cheques", feature: "instruments" },
  "online-payments": { title: "Online payments", feature: "online_payments" },
  reconciliation: { title: "Payment reconciliation", feature: "reconciliation" },
  recovery: { title: "Recovery", feature: "recovery" },
  properties: { title: "Buildings and units", feature: "properties" },
  configuration: { title: "Finance configuration", feature: "configuration" },
  "opening-reconciliation": { title: "Opening reconciliation", feature: "opening_reconciliation" },
  "provider-settings": { title: "Provider settings", feature: "provider_settings" },
};
